import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";
import type { ApiResponse } from "../types/api";

/** Map of language code to banner text (e.g. { en: "...", ar: "..." }) */
export type PromotionalBannerTexts = Record<string, string>;

export interface PromotionalBanner {
  category: string;
  texts: PromotionalBannerTexts;
  status: boolean;
  isPrimary: boolean;
}

export type PromotionalBannerUpdateBody = Partial<PromotionalBanner>;

interface PromotionalBannersListResponse {
  list?: Array<
    PromotionalBanner & { _id: string; createdAt?: string }
  >;
  data?: Array<
    PromotionalBanner & { _id: string; createdAt?: string }
  >;
  totalCount?: number;
}

export const promotionalBannersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPromotionalBanners: builder.query<
      ApiResponse<PromotionalBannersListResponse>,
      { page: number; limit: number; search: string }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.promotionalBanners}?page=${page}&limit=${limit}&search=${search}`,
        method: "GET",
      }),
    }),
    getPromotionalBannerById: builder.query<
      ApiResponse<PromotionalBanner & { _id: string }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.promotionalBanners}/${id}`,
        method: "GET",
      }),
    }),
    createPromotionalBanner: builder.mutation<
      ApiResponse<PromotionalBanner & { _id: string }>,
      { data: PromotionalBanner }
    >({
      query: (body) => ({
        url: END_POINTS.promotionalBanners,
        method: "POST",
        body: body?.data,
      }),
    }),
    updatePromotionalBanner: builder.mutation<
      ApiResponse<PromotionalBanner & { _id: string }>,
      { id: string; body: PromotionalBannerUpdateBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.promotionalBanners}/${id}`,
        method: "PUT",
        body: body,
      }),
    }),
    deletePromotionalBanner: builder.query<
      ApiResponse<{ _id: string }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.promotionalBanners}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useLazyGetAllPromotionalBannersQuery,
  useLazyGetPromotionalBannerByIdQuery,
  useCreatePromotionalBannerMutation,
  useUpdatePromotionalBannerMutation,
  useLazyDeletePromotionalBannerQuery,
} = promotionalBannersApi;
